import { ContentFragmentElements } from '../ReactCarousel'
import { Elements } from '../ReactTeaser'

export enum ListType {
  static = 'static',
  featuredCategory = 'featuredCategory',
  differentIcons = 'differentIcons',
  cfList = 'cfList',
  customList = 'customList'
}

export type ReactListItemsProps = {
  id?: string
  path?: string
  pageTitle?: string
  lastModified?: number
  description?: string
  title?: string
  link?: string
  openinnewtab?: string
  anchor?: string
  icon?: string
  iconAlt?: string
}

export interface ReactListProps {
  listFrom?: string
  id?: string
  icon?: string
  heading?: string
  isInEditor?: boolean
  dateFormatString?: string
  fixedListItems?: Array<ReactListItemsProps>
  linkItems?: boolean
  showDescription?: boolean
  showModificationDate?: boolean
  componentProperties?: object
  differentIconsList?: Array<ReactListItemsProps>
  altIcon?: string
  top?: boolean
  right?: boolean
  bottom?: boolean
  left?: boolean
  lob?: string
  cfListItems?: Array<any>
  ruleExpression?: string
  elements?: Elements | ContentFragmentElements
  tokenProperties?: string
  index?: any
  maxLength?: number
  hideMCP?: boolean
}

export interface CategoryItemType {
  title?: string
  id?: string
  iconAlt?: string
  description?: string
  link?: string
  openinnewtab?: string
  asset?: string
  icon?: string
  anchor?: string
}
